import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends, toConsumableArray as _toConsumableArray } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { FormItem, FormLabel, FormInputChoiceGroup } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';

var _excluded = ["children", "required"],
  _excluded2 = ["onChange"];

// TODO: maybe support children like radio group ?? :shrug:
// import { CheckboxGroupContext } from './context';

// TODO: maybe support children like radio group ?? :shrug:
// const Checkbox = ({ value, label }) => {
//   return (
//     <FormItem error={showError} variant="choice" disabled={disabled}>
//     {label ? <FormLabel htmlFor={id} text={label} caption={caption} tooltip={tooltip} disabled={disabled} /> : null }
//     <FormInputChoice {...defaultHandler} {...inputProps} type="checkbox" inputRef={formFieldRef} readOnly={readonly} checked={!!value} />
//     <FeedBack feedback={feedback} helper={helper} error={error} showError={showError} />
//   </FormItem>
//   )
// };

function CheckboxGroup(_ref) {
  _ref.children;
    var required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useField = useField(_objectSpread2(_objectSpread2({}, props), {}, {
      required: required
    })),
    informed = _useField.informed,
    fieldApi = _useField.fieldApi,
    fieldState = _useField.fieldState,
    render = _useField.render,
    userProps = _useField.userProps;
  var label = userProps.label,
    options = userProps.options,
    helper = userProps.helper,
    feedback = userProps.feedback,
    disabled = userProps.disabled;
  var showError = fieldState.showError,
    error = fieldState.error;

  // Take off on change
  informed.onChange;
    var rest = _objectWithoutProperties(informed, _excluded2);

  // TODO: maybe support children like radio group ?? :shrug:
  // const context = {
  //   radioGroupHandler: {
  //     ...defaultHandler,
  //   },
  //   radioGroupContext: {
  //     ...formFieldState,
  //   },
  // };

  var onOptionSelect = function onOptionSelect(val) {
    // Get current array
    var curValue = fieldApi.getValue() || [];
    // Get the change value
    var changeValue = val;
    // See if its already in array
    if (curValue.includes(changeValue)) {
      // If it does take it out
      var newVal = curValue.filter(function (v) {
        return v != changeValue;
      });
      // Set val
      fieldApi.setValue(newVal);
    } else {
      // Its not in yet so add!
      var _newVal = [].concat(_toConsumableArray(curValue), [changeValue]);
      // Set val
      fieldApi.setValue(_newVal);
    }
  };
  var wrappedOptions = useMemo(function () {
    return options.map(function (o) {
      return _objectSpread2(_objectSpread2({}, o), {}, {
        onBlur: informed.onBlur,
        onFocus: informed.onFocus
      });
    });
  }, [options]);
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    disabled: disabled
  }, label ? /*#__PURE__*/React.createElement(FormLabel, null, label) : null, /*#__PURE__*/React.createElement(FormInputChoiceGroup, _extends({}, rest, userProps, {
    type: "checkbox",
    onOptionSelect: onOptionSelect,
    options: wrappedOptions,
    selected: fieldState.value
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError
  })));
}

export { CheckboxGroup };
